// extracted by mini-css-extract-plugin
export default {"colorsRow":"AOIEditLineModal_colorsRow__p8ZQn"};